import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout/Layout';
import api from '../../api/axios';

function StatCard({ icon, value, label, colorClass }) {
  return (
    <div className="stat-card">
      <div className={`stat-icon ${colorClass}`}>{icon}</div>
      <div>
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
}

function fmt(dt) {
  if (!dt) return '—';
  return new Date(dt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/attendance/dashboard')
      .then(res => setStats(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div style={{ textAlign: 'center', padding: '3rem' }}><span className="spinner spinner-dark" /></div></Layout>;

  return (
    <Layout>
      <div className="page-header">
        <h1>Admin Dashboard</h1>
        <p>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </div>

      <div className="stats-grid">
        <StatCard icon="👥" value={stats?.total_staff ?? 0} label="Total Staff" colorClass="stat-icon-blue" />
        <StatCard icon="✅" value={stats?.signed_in_today ?? 0} label="Signed In Today" colorClass="stat-icon-green" />
        <StatCard icon="❌" value={stats?.absent_today ?? 0} label="Absent Today" colorClass="stat-icon-red" />
        <StatCard icon="⏰" value={stats?.late_today ?? 0} label="Late Today" colorClass="stat-icon-yellow" />
      </div>

      <div className="card">
        <h2 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '1rem', color: '#475569' }}>TODAY'S RECENT SIGN-INS</h2>
        {!stats?.recent_attendance?.length ? (
          <div className="empty-state" style={{ padding: '2rem' }}>
            <p>No attendance recorded today yet.</p>
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Staff</th><th>Department</th><th>Sign In</th><th>Sign Out</th><th>Status</th></tr>
              </thead>
              <tbody>
                {stats.recent_attendance.map(r => (
                  <tr key={r.id}>
                    <td>
                      <div style={{ fontWeight: 500 }}>{r.full_name}</div>
                      <div style={{ color: '#64748b', fontSize: '0.8rem' }}>{r.staff_id}</div>
                    </td>
                    <td>{r.department}</td>
                    <td>{fmt(r.sign_in_time)}</td>
                    <td>{fmt(r.sign_out_time)}</td>
                    <td><span className={`badge badge-${r.status}`}>{r.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
